import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { get } from 'lodash-es';

import { RootStateType } from '@store/store';

import { isString } from '@util/data/is-exist';

export const portalQuery = (url = '/') =>
  fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_PORTAL_URL}${url}`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootStateType).auth.data.token;
      if (isString(token)) headers.set('authorization', `Bearer ${token}`);
      return headers;
    },
  });

export const apiQuery =
  (url = '/', isApplication: boolean) =>
  (baseUrl: string) =>
    fetchBaseQuery({
      baseUrl: `${baseUrl}${url}`,
      prepareHeaders: (headers, { getState }) => {
        const token = get(getState() as RootStateType, [
          isApplication ? 'applications' : 'consumers',
          'meta',
          'accessToken',
        ]);
        if (isString(token)) headers.set('authorization', `Bearer ${token}`);
        return headers;
      },
    });
